import app from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

const config = {
    apiKey: "AIzaSyD6xZf5Mxk_4f5ihfHADNKFzAjp4JMJ2bY",
    authDomain: "support-ad895.firebaseapp.com",
    databaseURL: "https://support-ad895.firebaseio.com",
    projectId: "support-ad895",
    storageBucket: "support-ad895.appspot.com",
    messagingSenderId: "664194064050",
    appId: "1:664194064050:web:97ff904c230fc09e"
}

class Firebase {
    constructor() {
        app.initializeApp(config)

        this.auth = app.auth()
        this.database = app.database()
        
    }

    signInWithEmailAndPassword(email, password) {
        return this.auth.signInWithEmailAndPassword(email, password)
    }

    signOut() {
        this.auth.signOut()
    }
}

export default Firebase